// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchbar-custom[data-v-30bdea3e] {\r\n  max-width: 450px;\n}\r\n", ""]);
// Exports
module.exports = exports;
